module.exports = __webpack_public_path__ + "media/images/flags/64/Falkland-Islands-1ed319795c7fae259bb86585d82f4e9a.png";